import request from '@/utils/request'
import {
  getToken,
  getAppId,
  getProject,
  getCompany,
} from '@/utils/auth'

export function getApi (url, data) {
  const params = {
    project: getProject(),
    userId: getToken(),
    company: getCompany(),
    appId: getAppId(),
    ...data
  }
  return request({
    url,
    method: 'get',
    params
  })
}

export function postApi (url, data) {
  const params = {
    project: getProject(),
    userId: getToken(),
    company: getCompany(),
    appId: getAppId(),
    ...data
  }
  return request({
    url,
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js